import React from 'react';


const Info = () =>{

    return(
            <div className="about__info grid">
                <div className="about__box">
                <i class='bx bx-award about__icon' ></i>
                    <h3 className="about__title">Experience</h3>
                        <span className="about__subtitle">4 Internships</span>
                    
                </div>

                <div className="about__box">
                <i class='bx bx-briefcase-alt about__icon' ></i>
                    <h3 className="about__title">Completed</h3>
                        <span className="about__subtitle">Over 10 Projects</span>
                    
                </div>

                <div className="about__box">
                <i class='bx bx-buildings about__icon' ></i>
                    <h3 className="about__title">Business</h3>
                        <span className="about__subtitle">2 Startups</span>
                    
                </div>

                <div className="about__box">
                <i class='bx bx-certification about__icon' ></i>
                    <h3 className="about__title">Certifications</h3>
                        <span className="about__subtitle">+10 Certifications</span>
                </div>
            </div>
            
    )
}


export default Info